import PropTypes from 'prop-types';
import React from 'react';
import {withRouter} from 'react-router';
import {withApollo} from '@apollo/client/react/hoc';

import {createForm} from '@utils/forms';
import ThirdPartyClientTunnelsForm from '@modules/client/forms/ClientPackageTunnels/ThirdPartyClientTunnelsForm';
import ThirdPartyClientTunnelsModel from '@modules/client/forms/ClientPackageTunnels/ThirdPartyClientTunnelsModel';

const ClientTunnelModalContent = ({props, variables, formParams}) => {
    let Form = createForm(
        () =>ThirdPartyClientTunnelsModel(props, variables, formParams),
        ThirdPartyClientTunnelsForm,
        { ...variables, ...props.formValues}
    );

    return <Form />;
};

ClientTunnelModalContent.propTypes = {
    props: PropTypes.object,
    formValues: PropTypes.object,
    variables: PropTypes.object,
    formParams: PropTypes.object,
    match: PropTypes.shape({
        path: PropTypes.string.isRequired,
        params: PropTypes.shape({
            id: PropTypes.number,
        }),
    }),
};
export default withRouter(withApollo(ClientTunnelModalContent));
